export { default as Banner } from './component';
